import { Row } from 'components/shared/Layout';
import styled from 'styled-components';

export const InfoContainer = styled(Row)`
  &:not(.pax-extra-totals) {
    margin-bottom: 8px;
  }

  &.total-container {
    margin-top: 8px;
    .label,
    .value,
    .price {
      border-top: solid black 1px;
      border-bottom: solid black 1px;
    }
  }
`;

export const InfoLabel = styled('span')`
  font-weight: bold;
`;
